import { render, staticRenderFns } from "./terms-policy.vue?vue&type=template&id=53fb0d8e&scoped=true&lang=pug&"
import script from "./terms-policy.vue?vue&type=script&lang=js&"
export * from "./terms-policy.vue?vue&type=script&lang=js&"
import style0 from "./terms-policy.vue?vue&type=style&index=0&id=53fb0d8e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb0d8e",
  null
  
)

export default component.exports